module.exports = __webpack_public_path__ + "static/media/lifeskills.0dd978e5.svg";